<template>
  <div>
    <v-data-table
        :headers="headersClientPersons"
        :loading="areClientPersonsFetching"
        :items="clientPersons"
        :no-data-text="languageData.noDataClientPersonsText"
      >
      <template v-slot:item.client_person_type="{ item }">
        <v-chip v-for="(type, index) in item.client_person_type" class="my-1" v-bind:key="index">
          {{ languageData.clientPersonsTypes[type.value]  }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <template v-if="layout !== 'choosePerson' && layout !== 'timeReport'">
          <v-tooltip top :disabled="item.email ? true : false">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  color="primary"
                  @click="choosePersonAndSendInvoice(item)"
                  :disabled="!item.email"
                  :loading="item === dataSendIsFetching[dataSendIsFetching.indexOf(item)]">
                {{ languageData.labels.send }}
                </v-btn>
              </div> 
            </template>
            <span>{{ languageData.clientPersons.emailRequiredTooltip }}</span>
          </v-tooltip>
        </template>
        <template v-if="layout === 'timeReport'">
          <v-tooltip top :disabled="item.email ? true : false">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  color="primary"
                  @click="choosePersonAndsendTimeReport(item)"
                  :disabled="!item.email"
                  :loading="item === dataTimeReportSendIsFetching[dataTimeReportSendIsFetching.indexOf(item)]">
                {{ languageData.labels.send }}
                </v-btn>
              </div> 
            </template>
            <span>{{ languageData.clientPersons.emailRequiredTooltip }}</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-tooltip top v-if="layout !== 'invoice'">
            <template v-slot:activator="{}">
              <v-tooltip top :disabled="item.email ? true : false">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click="openSendDocumentForm(item)"
                      :disabled="!item.email">
                      <v-icon>
                        mdi-email-edit
                      </v-icon>
                    </v-btn>
                  </div> 
                </template>
                <span>{{ languageData.clientPersons.emailRequiredTooltip }}</span>
              </v-tooltip>
            </template>
            <span>{{ languageData.documents.createEmailAndSend }}</span>
          </v-tooltip>
        </template>
      </template>
    </v-data-table>
    <ModalInfo :hidden-agree-btn="true" :layout="'sendEmailForm'" @clicked="hideSendDocumentForm" :show-modal="showSendDocumentFormModal">
      <template v-slot:header>
          {{ languageData.documents.sendDocument + ' ' + document.id + ' ' + languageData.documents.sendTo + ' ' + chosenPerson}}
      </template>
      <template v-slot:body>
        <SendDocumentForm :clientPerson="clientPerson"></SendDocumentForm>
      </template>
    </ModalInfo>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import SendDocumentForm from "../../../Documents/components/SendDocumentForm/SendDocumentForm";
import eventBus from "../../../../event-bus/eventBus";

export default {
  name: "ClientPersonsList",
  components: {ModalInfo, SendDocumentForm},
  props: {
    layout: String,
    clientPersons: Array,
  },
  data() {
    return {
      clientPerson: null,
      showSendDocumentFormModal: false,
      chosenPerson: null,
    }
  },
  computed: {
    ...mapState("getHeadersClientPersons", {
      headersClientPersons: state => state.headersClientPersons
    }),
    ...mapState("getInvoiceClientPersons", {
      areClientPersonsFetching: state => state.areClientPersonsFetching
    }),
    ...mapState("sendInvoice", {
      invoice: state => state.invoice,
      dataSendIsFetching: state => state.dataSendIsFetching
    }),
     ...mapState("sendTimeReport", {
      timeReport: state => state.timeReport,
      dataTimeReportSendIsFetching: state => state.dataTimeReportSendIsFetching
    }),
    ...mapState("sendDocument", {
      document: state => state.document,
    }),
  },
  watch: {
    clientPerson () {
      this.chosenPerson = this.clientPerson === null ? '' : this.clientPerson.email;
    }
  },
  methods: {
    ...mapActions('getHeadersClientPersons', ["getHeadersClientPersons"]),
    ...mapActions('sendInvoice', ["sendInvoice"]),
    ...mapActions('sendDocument', ["sendDocument"]),
    ...mapActions("sendTimeReport", ["sendTimeReport"]),

    choosePersonAndsendTimeReport(item) {
      this.sendTimeReport({creds: {
          clientPerson: item,
          timeReport: this.timeReport,
        }});
    },
    choosePersonAndSendInvoice(item) {
      this.sendInvoice({creds: {
          clientPerson: item,
          invoice: this.invoice,
        }});
    },
    openSendDocumentForm(item) {
      this.clientPerson = item;
      this.showSendDocumentFormModal = true;
    },
    hideSendDocumentForm() {
      this.showSendDocumentFormModal = false;
    }
  },
  mounted(){
    const language = this.getCurrentLanguage;
    this.getHeadersClientPersons({ creds: { language } });
    eventBus.$on('sendDocumentSuccess', () => {
      this.showSendDocumentFormModal = false;
    });
  }
}

</script>